import { ajax } from 'cadenza/api-client/api';
import type {
  DeletionDeadlineConfigurationDto,
  DeletionDeadlineInfoDto,
} from 'cadenza/api-client/dto/deletion-deadline-dto';
import { isFeatureAvailable } from 'cadenza/features';
import { MIMETYPE_JSON } from 'cadenza/model/media-type';
import type { WorkbookId } from 'cadenza/repository/model/workbook-id.gen';

/**
 * Returns the deletion deadline configuration from the backend or undefined if the feature
 * is not available.
 */
export function readDeletionDeadlineConfiguration() {
  if (isFeatureAvailable('DELETION_DEADLINE')) {
    return ajax<DeletionDeadlineConfigurationDto>('/config/deletion-deadlines');
  }
}

export function getWorkbookDeletionDeadline({ repositoryName, itemName }: WorkbookId) {
  if (isFeatureAvailable('DELETION_DEADLINE')) {
    return ajax<DeletionDeadlineInfoDto>(`/repositories/${repositoryName}/workbooks/${itemName}/deletion-deadline`);
  }
}

export function updateWorkbookDeletionDeadline(
  { repositoryName, itemName }: WorkbookId,
  deletionDeadlineInfo: DeletionDeadlineInfoDto,
) {
  return ajax<void>(`/repositories/${repositoryName}/workbooks/${itemName}/deletion-deadline`, {
    method: 'PUT',
    contentType: MIMETYPE_JSON,
    data: JSON.stringify(deletionDeadlineInfo),
  });
}
